import { render } from "./DashboardCalendar.vue?vue&type=template&id=f997acdc&scoped=true"
import script from "./DashboardCalendar.vue?vue&type=script&lang=js"
export * from "./DashboardCalendar.vue?vue&type=script&lang=js"

import "./DashboardCalendar.vue?vue&type=style&index=0&id=f997acdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f997acdc"]])

export default __exports__